<template>
  <DxDrawer opened-state-mode="shrink" position="right" reveal-mode="expand" v-model:opened="drawerOpen"
    :close-on-outside-click="false" template="list">
    <template #list>
      <!-- <div class="divGroup" style="width: 40vw"> -->
      <!-- <div class="divGroup"> -->
      <div>
        <div style="width: 45vw">
          <!-- Container Name Edit Section -->
          <div v-if="editingContainerName">
            <div class="propHeader">
              Surface Name
            </div>
            <div class="propThreshold">
              <DxTextBox id="containerName" :width="auto" label="Surface Name" :value="editContainerName"
                :max-length="50" @value-changed="containerNameChanged" />
            </div>
            <div class="buttons">
              <DxButton class="saveBtn" icon="save" text="Save" @click="saveContainerName" />
              <DxButton class="cancelBtn" text="Cancel" @click="closeContainerNameEdit" />
            </div>
          </div>

          <!-- Property Edit Section -->
          <!-- <div v-if="allowValueEditing(selectedProp.propertyName)"> 241020 -->
          <div v-else-if="allowUserEdit(selectedProp)">
            <div class="propHeader">
              {{ selectedProp.status }} {{ selectedProp.propertyName }}
            </div>
            <!-- <div class="propVal">{{ selectedProp.status}} {{selectedProp.propValue}}</div> -->
            <div class="propThreshold">
              <DxNumberBox v-if="['number', 'decimal'].includes(selectedProp.propertyType.toLowerCase())"
                :value-type="selectedProp.propertyType" id="value" :width="auto" label="Value" @key-down="handleKeyDown"
                :value="selectedProp.propValue" @value-changed="propValueChanged" />
              <DxTextBox v-else :value-type="selectedProp.propertyType" id="value" :width="auto" label="Value"
                :value="selectedProp.propValue" :max-length="50" @value-changed="propValueChanged" />
            </div>
          </div>
          <div v-else>
            <div class="propHeader">{{ selectedProp.propertyName }}</div>
            <div class="propVal">
              {{ selectedProp.status }} {{ selectedProp.propValue }}
            </div>
          </div>
          <div v-if="allowPropThresholds(selectedProp)">
            <div class="propThreshold">
              <DxNumberBox id="marginal" :width="auto" label="Marginal Threshold" :value="selectedProp.valueMarginal"
                @key-down="handleKeyDown" @value-changed="propValueChanged" />
            </div>
            <div class="propThreshold">
              <DxNumberBox id="critical" :width="auto" label="Critical Threshold" :value="selectedProp.valueCritical"
                @key-down="handleKeyDown" @value-changed="propValueChanged" />
            </div>
          </div>
          <div v-if="allowPropHighThresholds(selectedProp)">
            <div class="propThreshold">
              <DxNumberBox id="highMarginal" :width="auto" label="High Marginal Threshold"
                :value="selectedProp.valueHighMarginal" @key-down="handleKeyDown" @value-changed="propValueChanged" />
            </div>
            <div class="propThreshold">
              <DxNumberBox id="highCritical" :width="auto" label="High Critical Threshold"
                :value="selectedProp.valueHighCritical" @key-down="handleKeyDown" @value-changed="propValueChanged" />
            </div>
          </div>
          <div v-if="!editingContainerName" class="buttons">
            <DxButton class="saveBtn" icon="save" text="Save" @click="saveProperty" />
            <DxButton class="cancelBtn" text="Cancel" @click="closeProperty" />
          </div>
        </div>
      </div>
    </template>
    <div class="divFilter">
      <DxBox :height="45">
        <DxItem :ratio="1">
          <DxTextBox class="filterSearch" placeholder="Search properties..." :width="auto" :show-clear-button="true"
            v-bind:value="searchVal" @value-changed="searchChange" />
        </DxItem>
        <DxItem :ratio="1">
          <DxButtonGroup class="filterBtn" :items="statusFilter" :selected-item-keys="['all']" key-expr="status"
            styling-mode="outline" @selection-changed="filterToggle" />
        </DxItem>
      </DxBox>
    </div>
    <hr style="height: 1px; border: 1px solid #444" />

    <DxScrollView :width="auto" :height="400" direction="both">
      <div class="divGroup" id="containerInfo">
        <div v-if="!isOperator" class="container-name-section">
          <div class="propHeader">
            <span>Surface Name </span>
            <span style="cursor: pointer; color:rgba(255, 115, 0, 0.7);" @click="openContainerNameEdit"> ✎ </span>
          </div>
          <div class="propVal">{{ container.containerName }}</div>
          <hr style="height: 1px; border: 1px solid #444" />
        </div>

        <div v-for="prop in container.properties" :key="prop.containerPropId">
          <div v-if="filterCheck(prop.propertyName, prop.status)">
            <div class="propHeader">
              <div class="propHeader" v-if="allowUserEdit(prop)">
                <span>{{ prop.propertyName }} </span>
                <span style="cursor: pointer; color:rgba(255, 115, 0, 0.7);" @click="openProperty(prop)"> ✎ </span>
              </div>
              <div class="propHeader" v-else>{{ prop.propertyName }}</div>
              <div class="propVal">{{ prop.status }} {{ prop.propValue }}</div>
              <div v-if="
                (prop.propertyType === 'NUMBER' ||
                  prop.propertyType === 'DECIMAL') &&
                prop.useThresholds
              ">
                <div class="propThreshold">
                  Low Critical: {{ prop.valueCritical }}
                </div>
                <div class="propThreshold">
                  Low Marginal: {{ prop.valueMarginal }}
                </div>
              </div>
              <div v-if="
                (prop.propertyType === 'NUMBER' ||
                  prop.propertyType === 'DECIMAL') &&
                prop.useHighThresholds
              ">
                <div class="propThreshold">
                  High Marginal: {{ prop.valueHighMarginal }}
                </div>
                <div class="propThreshold">
                  High Critical: {{ prop.valueHighCritical }}
                </div>

              </div>
            </div>
            <hr style="height: 1px; border: 1px solid #444" />
          </div>
        </div>
      </div>
    </DxScrollView>
  </DxDrawer>
</template>

<script>
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxTextBox from "devextreme-vue/text-box";
import DxButton from "devextreme-vue/button";
import { DxBox, DxItem } from "devextreme-vue/box";
import DxButtonGroup from "devextreme-vue/button-group";
import DxDrawer from "devextreme-vue/drawer";
import DxNumberBox from "devextreme-vue/number-box";

export default {
  components: {
    DxScrollView,
    DxTextBox,
    DxButton,
    DxBox,
    DxItem,
    DxButtonGroup,
    DxDrawer,
    DxNumberBox
  },
  props: ["containerId", "container", "isOperator"],
  created() {
    this.loadPageData();
  },
  data() {
    return {
      // container: {},
      searchVal: "",
      searchStatus: "",
      ctrlOver: "",
      selectedProp: "",
      drawerOpen: false,
      selectedOpenMode: "push",
      selectedPosition: "right",
      selectedRevealMode: "expand",
      editingContainerName: false,
      editContainerName: "",
      statusFilter: [
        {
          status: "",
          hint: "All",
          text: "✪",
        },
        {
          status: "✔️",
          hint: "Good",
          text: "✔️",
        },
        {
          status: "⚠️",
          hint: "Marginal",
          text: "⚠️",
        },
        {
          status: "❌",
          hint: "Critical",
          text: "❌",
        },
      ],
    };
  },
  // watch: {
  //   async containerId (){
  //     await this.$store.dispatch("containers/loadContainerStatus", this.containerId )
  //     this.container = this.$store.getters["containers/getContainerStatus"];
  //   },
  // },
  computed: {},
  methods: {
    allowValueEditing(propName) {
      console.log(propName);
      if (
        propName == "Alias" ||
        propName == "Downhole LSD" ||
        propName == "Injection Target" ||
        propName == "Heel Inventory" ||
        propName == "Capacity Useable"
      )
        return true;
      else return false;
    },
    // The container's property name follows the user's unit system and may not
    // match the master list's, so match on propertyId and fall back to the name.
    propertyDef(containerProp) {
      if (!containerProp) return null;
      const props = this.$store.getters["properties/getProperties"] || [];
      return (
        props.find((x) => x.propertyId == containerProp.propertyId) ||
        props.find(
          (x) =>
            x.propertyName == containerProp.propertyName ||
            x.propertyNameMetric == containerProp.propertyName
        ) ||
        null
      );
    },
    allowUserEdit(containerProp) {
      const prop = this.propertyDef(containerProp);
      if (!prop) return false;

      if (this.isOperator) return false;
      if (prop.userEdit || prop.useThresholds || prop.useHighThresholds) return true;

      return false;
      // return this.isOperator ? prop.userEdit && prop.editOperator : prop.userEdit;

    },
    allowPropThresholds(containerProp) {
      const prop = this.propertyDef(containerProp);
      return !!(prop && prop.useThresholds);
    },
    allowPropHighThresholds(containerProp) {
      const prop = this.propertyDef(containerProp);
      return !!(prop && prop.useHighThresholds);
    },
    // allowValueThresholds(propName){
    //   return this.container.properties.filter(x => x.propertyName == propName)[0].useThresholds;
    // },
    loadPageData() { },
    searchChange(e) {
      this.searchVal = e.value;
    },
    setEditVisibility(ctrlName) {
      this.ctrlOver = ctrlName;
    },
    filterToggle(e) {
      if (e.addedItems[0]) {
        this.searchStatus = e.addedItems[0].status;
      }
    },
    filterCheck(propName, propStatus) {
      let filter = false;

      filter = propName.toLowerCase().includes(this.searchVal.toLowerCase());
      if (filter && this.searchStatus.length > 0) {
        filter = propStatus == this.searchStatus;
      }
      return filter;
    },
    propValueChanged(e) {
      // console.log(e)
      // console.log(e.element.id)
      // console.log(e.value)
      if (e.element.id == "marginal") this.selectedProp.valueMarginal = e.value;
      else if (e.element.id == "critical")
        this.selectedProp.valueCritical = e.value;
      else if (e.element.id == "highMarginal")
        this.selectedProp.valueHighMarginal = e.value;
      else if (e.element.id == "highCritical")
        this.selectedProp.valueHighCritical = e.value;
      else if (e.element.id == "value") this.selectedProp.propValue = e.value;
    },
    openProperty(prop) {
      console.log(`prop ==> ${JSON.stringify(prop)}`);
      this.selectedProp = prop;
      this.drawerOpen = !this.drawerOpen;
    },
    closeProperty() {
      this.drawerOpen = !this.drawerOpen;
    },
    saveProperty() {
      const prop = {
        containerPropId: this.selectedProp.containerPropId,
        containerId: this.container.containerId,
        propertyId: this.selectedProp.propertyId,
        propValue: String(this.selectedProp.propValue),
        marginal: this.selectedProp.valueMarginal,
        critical: this.selectedProp.valueCritical,
        highMarginal: this.selectedProp.valueHighMarginal,
        highCritical: this.selectedProp.valueHighCritical,
        propertySort: 0,
      };
      this.$store.dispatch("containers/updateContainerProperty", prop);
      this.$emit("recordUpdated");
      this.closeProperty();
    },
    openContainerNameEdit() {
      this.editingContainerName = true;
      this.editContainerName = this.container.containerName;
      this.drawerOpen = true;
    },
    closeContainerNameEdit() {
      this.editingContainerName = false;
      this.editContainerName = "";
      this.drawerOpen = false;
    },
    containerNameChanged(e) {
      this.editContainerName = e.value;
    },
    saveContainerName() {
      const containerUpdate = {
        containerId: this.container.containerId,
        containerName: this.editContainerName,
      };
      this.$store.dispatch("containers/updateContainerName", containerUpdate);
      this.$emit("recordUpdated");
      this.closeContainerNameEdit();
    },
    handleKeyDown(e) {
      if (e.event.key === 'e' || e.event.key === 'E') {
        e.event.preventDefault()
      }
    }
  },
};
</script>

<style scoped>
.divGroup {
  width: 90%;
  border-style: solid;
  border-width: 1px;
  margin: 20px;
  border-color: rgb(100, 100, 100);
  border-radius: 6px;
  padding: 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.divFilter {
  width: 85%;
  border-style: none;
  margin: 0 20px 0 20px;
  padding: 20px;
  /* box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); */
}

.filterSearch {
  margin: 0 10px 0 0;
  border-radius: 6px;
}

.filterBtn {
  /* margin: 0 0 0 0; */
  padding: 5px;
  width: 30%;
  border-radius: 6px;
}

.propHeader {
  font-size: 16px;
  font-weight: 300;
  color: rgb(255, 255, 255, 0.7);
  margin-bottom: 6px;
  z-index: 20;
}

.propVal {
  font-size: 14px;
  font-weight: 300;
  margin-left: 10px;
  margin-bottom: 10px;
  z-index: 20;
}

.propThreshold {
  width: 80%;
  font-size: 12px;
  font-weight: 300;
  color: rgb(255, 255, 255, 0.3);
  margin-left: 10px;
  margin-bottom: 2px;
  z-index: 20;
  padding: 2px;
}

.hr {
  height: 1px;
  border: 1px solid #444;
}

.buttons {
  width: 200px;
  margin: 0 auto;
  display: inline;
}

.saveBtn {
  color: black;
  background-color: rgb(255, 115, 0);
  /* margin: 0 20px 20px 0; */
  margin: 0 10px auto;
  width: 100px;
  display: inline-block;
  /* float: left; */
}

.cancelBtn {
  color: black;
  background-color: rgb(255, 255, 255, 0.3);
  /* margin: 0 20px 20px 0; */
  margin: 0 auto;
  width: 100px;
  display: inline-block;
  /* float: right; */
  /* display: flex; */
  /* justify-content: flex-end; */
}

.buttons {
  width: 100px;
  margin: 0 auto;
}

.container-name-section {
  margin-bottom: 10px;
}
</style>
